import { KLineData } from "klinecharts";
import { readStyle } from "./indicatorUtils";

export const createAcceleratorOscillator = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const upS = readStyle(styles, "acUp", "#26A69A");
  const downS = readStyle(styles, "acDown", "#EF5350");

  return {
    name: "ac",
    shortName: "AC",
    calcParams: [] as number[],
    series: "normal" as const,
    figures: [{ key: "ac", title: "AC: ", type: "bar" }],
    styles: {
      bars: [
        {
          upColor: upS.color,
          downColor: downS.color,
          noChangeColor: "#888888",
        },
      ],
    },
    regenerateFigures: () => [{ key: "ac", title: "AC: ", type: "bar" }],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{ ac?: number }> = new Array(n);
      let sum5 = 0;
      let sum34 = 0;
      const aoBuf: number[] = new Array(5);
      let aoIdx = 0;
      let aoCount = 0;
      let aoSum = 0;

      for (let i = 0; i < n; i++) {
        const median = (dataList[i]!.high + dataList[i]!.low) / 2;
        sum5 += median;
        sum34 += median;
        if (i >= 5) sum5 -= (dataList[i - 5]!.high + dataList[i - 5]!.low) / 2;
        if (i >= 34)
          sum34 -= (dataList[i - 34]!.high + dataList[i - 34]!.low) / 2;

        if (i < 33) {
          results[i] = {};
          continue;
        }

        const ao = sum5 / 5 - sum34 / 34;
        const evicted = aoCount === 5 ? aoBuf[aoIdx]! : 0;
        aoBuf[aoIdx] = ao;
        aoIdx = (aoIdx + 1) % 5;
        if (aoCount < 5) aoCount++;
        aoSum += ao - evicted;

        if (aoCount < 5) {
          results[i] = {};
        } else {
          results[i] = { ac: ao - aoSum / 5 };
        }
      }

      return results;
    },
  };
};
